<template>
  <div class="px-1">
    <ul class="border-b border-t divide-y divide-ccc border-ccc">
      <date-filter-component />
      <filter-kind-component
        v-for="kind in kinds.slice(0, 6)"
        :key="kind"
        :kind="kind"
        :filterVisible="expandedFilters.includes(kind)"
        :expanded-items="expandedItems[kind]"
        @toggleFilter="toggleFilter"
        @toggleExpandedItem="toggleExpandedItem"
      />
      <filter-kind-component
        kind="COLOR"
        :filterVisible="expandedFilters.includes('COLOR')"
        @toggleFilter="toggleFilter"
      />
      <filter-kind-component
        v-for="kind in kinds.slice(6)"
        :key="kind"
        :kind="kind"
        :filterVisible="expandedFilters.includes(kind)"
        :expanded-items="expandedItems[kind]"
        @toggleFilter="toggleFilter"
        @toggleExpandedItem="toggleExpandedItem"
      />
    </ul>
  </div>
</template>

<i18n>
{
  "en": {
    "loading": "Filters are loading"
  },
  "de": {
    "loading": "Filter werden geladen"
  }
}
</i18n>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

import { Vocabulary } from '../@types/vocabulary';
import VocabularyKind from '../@types/vocabularyKind';
import { objectMap, toggle } from '../utils/utils';
import DateFilterComponent from './DateFilterComponent.vue';
import FilterKindComponent from './FilterKindComponent.vue';

export default defineComponent({
  name: 'DetailFilterComponent',

  components: {
    DateFilterComponent,
    FilterKindComponent,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const kinds = Object.keys(VocabularyKind);
    const expandedFilters: Ref<Vocabulary[]> = ref([]);
    const expandedItems: Ref<any> = ref(objectMap(VocabularyKind, () => []));

    const toggleFilter = (kind: VocabularyKind): void => {
      expandedFilters.value = toggle(expandedFilters.value, kind);
    };

    const toggleExpandedItem = (payload: {
      kind: VocabularyKind;
      item: string;
    }): void => {
      expandedItems.value[payload.kind] = toggle(
        expandedItems.value[payload.kind],
        payload.item
      );
    };

    return {
      kinds,
      expandedFilters,
      expandedItems,
      toggleFilter,
      toggleExpandedItem,
    };
  },
});
</script>
